import axios from 'axios'
import settings from '../../settings'
const languages = {
    namespaced: true,
    state: () => ({
        all:[]
      }),
      mutations:{
         updatelanguagesState(state,data){
             state.all=data;
         }
      },
      actions: {
        fetchLanguages({commit}){
            axios.get(`${settings.apiUrl}/languages`).then(res => {
					commit('updatelanguagesState',res.data)
			 });
        },
      },
    
      getters: {
           
      }
}

export default languages;

 